"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ComponentKeyMap = void 0;
var _react = _interopRequireDefault(require("react"));
var _YouAndYourPets = require("./YouAndYourPets/YouAndYourPets");
var _CoverOptions = require("./CoverOptions/CoverOptions");
var _YourDetails = require("./YourDetail/YourDetails");
var _Summary = require("./Summary/Summary");
var _Payment = require("./Payment/Payment");
var _Error = require("../ErrorHandler/Error");
var _Success = require("./Success/Success");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var ComponentKeyMap = exports.ComponentKeyMap = {
  'YouAndYourPets': /*#__PURE__*/_react["default"].createElement(_YouAndYourPets.YouAndYourPets, null),
  'CoverOptions': /*#__PURE__*/_react["default"].createElement(_CoverOptions.CoverOptions, null),
  'YourDetails': /*#__PURE__*/_react["default"].createElement(_YourDetails.YourDetails, null),
  'Summary': /*#__PURE__*/_react["default"].createElement(_Summary.Summary, null),
  'Payment': /*#__PURE__*/_react["default"].createElement(_Payment.Payment, null),
  'PaymentSuccess': /*#__PURE__*/_react["default"].createElement(_Success.Success, null),
  'ErrorPage': /*#__PURE__*/_react["default"].createElement(_Error.Error, null),
  'CustomerQuoteRetrieve': /*#__PURE__*/_react["default"].createElement(_YouAndYourPets.YouAndYourPets, {
    shouldRetrieveQuote: true
  }),
  'SetApplicationQuote': /*#__PURE__*/_react["default"].createElement(_YouAndYourPets.YouAndYourPets, null)
};